import { Link, useRouterState } from '@tanstack/react-router'
import { cn } from '@/shared/lib/utils'
import { useTranslation } from 'react-i18next'
import type { Resources } from 'i18next'
import WalletIcon from '@/ui/icons/WalletIcon'
import HandWavingIcon from '@/ui/icons/HandWavingIcon'
import CompassIcon from '@/ui/icons/CompassIcon'
import FlagIcon from '@/ui/icons/FlagIcon'
import HouseIcon from '@/ui/icons/HouseIcon'

type NavKey = `nav.${keyof Resources['app']['nav'] & string}`

interface NavItem {
  labelKey: NavKey
  path: string
  Icon: React.FC<{ className?: string }>
}

const NAV_ITEMS: NavItem[] = [
  { labelKey: 'nav.home', path: '/', Icon: HouseIcon },
  { labelKey: 'nav.earn', path: '/earn', Icon: FlagIcon },
  { labelKey: 'nav.dreampad', path: '/dream-pad', Icon: CompassIcon },
  { labelKey: 'nav.crew', path: '/crew', Icon: HandWavingIcon },
  { labelKey: 'nav.wallet', path: '/wallet', Icon: WalletIcon },
]

export const NavBar = () => {
  const { t } = useTranslation('app')
  const { location } = useRouterState()

  const isActive = (path: string) => location.pathname === path

  return (
    <nav className="fixed bottom-0 inset-x-0 z-20 pt-4 pb-safe-area bg-black/80 backdrop-blur-xs">
      <div className="app-container flex text-gray-600">
        {NAV_ITEMS.map(({ labelKey, path, Icon }) => (
          <Link
            key={path}
            to={path}
            className={cn(
              'nav-bar-buttons',
              isActive(path) && 'text-primary-500',
            )}
          >
            <Icon className="w-6 h-6" />
            {t(labelKey)}
          </Link>
        ))}
      </div>
    </nav>
  )
}
